// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  OnChanges,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ExtendedCoilModel } from 'src/app/_interfaces/coil/coil-extension-model';
import { CoilService } from '../../services/coil.service';

@Component({
  selector: 'app-coil-information',
  templateUrl: './coil-information.component.html',
  styleUrls: ['./coil-Information.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [TranslateModule, CommonModule],
})
export class CoilInformationComponent implements OnChanges {
  @Input({ required: true })
  coil!: ExtendedCoilModel;

  constructor(public coilservice: CoilService) {}

  ngOnChanges(): void {
    this.coilservice.getExternalLinks();
  }

  onClickOpenUrl(url: string): void {
    if (url) {
      window.open(url, '_blank');
    }
  }

  isRelevantInfoVisible(coilName: string): string {
    return coilName
      ?.toLowerCase()
      .includes('body_18'.toLowerCase() || 'body_30'.toLowerCase())
      ? 'visible'
      : 'hidden';
  }

  isReplacementCoilMaterialNumber(coilMaterialNumber: number): boolean {
    return coilMaterialNumber === 99999999;
  }
}
